import React from "react";
import { useFormik } from "formik";
import ForgotPasswordForm from "./forgot-password-form.component";
import { forgotPasswordSchema } from "src/validations/forgot-password-schema";
import moment from "moment";
import useLoadingError from "src/hooks/useLoadingError";
import { useNavigate } from "react-router-dom";
import { useCustomerForgotPasswordMutation } from "src/services/api-service/customer-auth";
import { showToast } from "src/utils";
import { TOASTR_TYPES } from "src/components/atoms/toast-container/types";

const ForgotPasswordFormContainer = () => {
  const navigate = useNavigate();
  const { loading, error, setErrorMsg, reset, startLoading, stopLoading } =
    useLoadingError();
  const [forgotPassword] = useCustomerForgotPasswordMutation();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: forgotPasswordSchema,
    validateOnBlur: true,
    validateOnChange: true,
    validateOnMount: true,
    onSubmit: async (values) => {
      startLoading();
      forgotPassword(values)
        .unwrap()
        .then((res: any) => {
          const { email } = formik.values;
          navigate(
            `/verify-otp?token=${res?.data?.otp_token}&email=${encodeURIComponent(email)}`,
          );
          showToast(TOASTR_TYPES.SUCCESS, res?.message);
          sessionStorage.setItem("otpRequestTimestamp", moment().format());
        })
        .catch((err) => {
          setErrorMsg(err?.data?.message);
        })
        .finally(() => {
          stopLoading();
        });
    },
  });

  return (
    <ForgotPasswordForm
      formik={formik}
      error={error}
      resetError={reset}
      loading={loading}
    />
  );
};

export default ForgotPasswordFormContainer;
